var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyscoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9553 8.9599C19.8649 7.92817 18.325 7.06872 16.327 6.52302H16.3154C11.561 5.2295 9.86711 8.28909 13.7169 10.2178C18.0873 12.4045 18.6946 15.9857 16.2279 18.2253C15.5994 18.795 13.5571 19.8614 11.6784 20.1174C8.69487 20.5313 5.38409 19.897 2.69312 19.0424C4.15672 20.1792 5.82931 21.0177 7.61598 21.5101C11.8112 22.665 16.8785 21.8142 20.2364 18.8951C23.6184 15.951 23.9418 11.7779 20.9553 8.9599Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18768 2.05739C9.50322 1.11359 12.0258 0.793671 14.5036 1.12958C16.9815 1.46548 19.3279 2.44546 21.3085 3.97168C16.2846 2.37404 12.3868 2.51263 9.82957 3.54147L9.79203 3.55687C6.63428 4.84846 5.53999 7.49227 6.91435 9.88296C7.65446 11.1717 8.95953 12.1351 10.2829 12.7963C13.7823 14.5489 12.7063 17.2331 8.91718 16.7422C8.49664 16.6862 8.08051 16.6009 7.67179 16.4872C0.231194 14.4555 -0.857321 8.1371 3.7643 4.11893C4.78452 3.24849 5.94112 2.55199 7.18768 2.05739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyscoin);
export default __webpack_public_path__ + "static/media/syscoin.57e8d6215b322a5e12002ec0ad6bbc0d.svg";
export { ForwardRef as ReactComponent };